import { parseJsonObject, parseString } from "@de-xima/xima-common-js-lang";

let newWindow: Window | undefined;

/**
 * Open the form by the given path.
 * @param path The path of the form.
 * @param isUserLoggedIn Whether the user is logged in.
 */
export function openForm(path: string, isUserLoggedIn: boolean): void {
  if (!isUserLoggedIn) {
    window.open(path, "_blank");
    return;
  }

  newWindow = window.open("about:blank", "_blank") ?? undefined;
  rcPrepareFormUrl?.([{ name: "path", value: path }]);
}

/**
 * Callback function for the form URL preparation.
 * @param args The PrimeFaces arguments object with the data received from the server.
 */
export function onFormUrlPrepareComplete(args: PrimeFaces.ajax.PrimeFacesArgs): void {
  if (newWindow) {
    const data = parseJsonObject(args.formAccessData);
    let formPath = parseString(data.formPath);
    const portalAlias = parseString(data.portalAlias);

    if (portalAlias) {
      formPath = appendParameterToUrl(formPath, "portal_alias", portalAlias);
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = formPath;

    newWindow.document.body.appendChild(form);
    form.submit();
  }
}

/**
 * Appends a given url parameter to the URL with the given key and value.
 * @param url the URL to append the parameter to.
 * @param urlParameterKey the key of the parameter to append.
 * @param urlParameterValue the value of the parameter to append.
 * @returns The URL with the appended parameter.
 */
export function appendParameterToUrl(url: string, urlParameterKey: string, urlParameterValue: string): string {
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.set(urlParameterKey, urlParameterValue);
  return urlObj.toString();
}
